export const achievementData = {
    bio : "My certifications in Microsoft Azure Fundamentals, AWS, Tableau, SAS Optimization, Google Data Analytics, and SQL and Python from DataCamp demonstrate extensive expertise across essential platforms and tools. These credentials enable me to enhance operational efficiency and leverage data-driven strategies effectively in various business environments.",
    achievements : [
        {
            id : 1,
            title : 'Microsoft Azure Fundamentals (AZ-900)',
            details : 'Provides foundational knowledge of Microsoft Azures cloud services, focusing on core functionalities, security features, and compliance across cloud environments.',
            date : 'Oct 7, 2023',
            field : 'Cloud Computing',
            image : 'azure_fundamentals copy.jpg'
        },
        {
            id : 2,
            title : 'AWS Certified Cloud Practitioner',
            details : 'Offers a broad understanding of AWS ecosystem, detailing essential services, security protocols, and architectural best practices for cloud solutions.',
            date : 'Dec 16, 2023',
            field : 'Cloud Computing',
            image : 'aws2 copy.png'
        },
        {
            id : 3,
            title : 'Tableau Desktop Specialist',
            details : 'Validates abilities in using Tableau to effectively create data visualizations and dashboards that translate complex datasets into actionable business insights.',
            date : 'Dec 30, 2023',
            field : 'Data Visualization',
            image : 'tableaudesktop copy.png'
        },
        {
            id : 4,
            title : 'Google Advanced Data Analytics',
            details : 'Develops advanced analytical skills using Google’s tools, focusing on leveraging big data, machine learning, and statistical methods to drive strategic decisions.',
            date : 'May 6, 2024',
            field : 'Data Analytics',
            image : 'google advanced.png'
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/